// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  AppPlatform,
  AppType,
  DistributionMode,
} from "./types";

export default {
  appId: __t.string(),
  displayName: __t.string(),
  description: __t.string(),
  get platform() {
    return AppPlatform;
  },
  get appType() {
    return AppType;
  },
  get distributionMode() {
    return __t.option(DistributionMode);
  },
  executablePath: __t.option(__t.string()),
  orgId: __t.string(),
};
